<template>
    <div class="h-[65svh] md:h-[70vh] min-h-80 md:min-h-140 relative">
        <AnimationParallax>
            <SlidesIntro :imgsprops="imgs" @index-change="indeChange" />
        </AnimationParallax>

        <div class="pointer-events-none absolute inset-x-0 bottom-22 md:bottom-2/16">
            <div class="my-container">
                <AnimationTexteIn :index="indexslide" :duration="6500" :content="slideContent" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ContentSlide } from '~/components/animation/TexteIn.vue';
import type { AirImgProps } from '~/types/image';

// const parallax = ref<HTMLElement | null>(null);
// const { isScrolling, isInViewport } = useScroll(parallax);
const indexslide = ref(0);

const imgs: AirImgProps[] = [
    {
        debug: true,
        src: 'DSC00696.jpg',
        preload: true,
        quality: 70,
        width: 412,
        height: 494,

        dpr: [1, 1.8],
        variant: [
            { breakpoint: 'default', trim: '800;0;0;0', gravity: [0.8, 1] },
            { breakpoint: 'sm', width: 768, height: 720, gravity: [0.8, 0.4], trim: '600;0;0;0' },
            { breakpoint: 'md', width: 768, height: 720, gravity: [0.8, 0], trim: '600;0;0;0' },
            { breakpoint: 'lg', width: 1264, height: 800, dpr: [1], gravity: [0.6, 0.6], quality: 80, trim: '500;0;0;800' },
            { breakpoint: 'xl', width: 1520, height: 947, dpr: [1], gravity: [1, 0], quality: 90, trim: '300;0;0;000' },
            { breakpoint: 'xxl', width: 1920, height: 947, dpr: [1], gravity: [0, 0.7], quality: 90, trim: '0;200;0;200' }
        ]
    },
    {
        src: 'IMG_20250215_210534.jpg',
        preload: false,
        quality: 70,
        width: 412,
        height: 494,
        gravity: [0, 0.5],
        dpr: [1, 1.8],

        variant: [
            { breakpoint: 'sm', width: 768, gravity: [0, 0] },
            { breakpoint: 'md', width: 768, height: 720, gravity: [0.1, 0.1] },
            { breakpoint: 'lg', width: 1264, height: 800, dpr: [1], gravity: [0, 0.6], quality: 80 },
            { breakpoint: 'xl', width: 1520, height: 947, dpr: [1], gravity: [0.5, 1], quality: 90 },
            { breakpoint: 'xxl', width: 1920, height: 800, dpr: [1], gravity: [0, 0.8], quality: 90 }
        ]
    },
    {
        debug: false,
        src: 'IMG_20250103_110136.jpg',
        preload: false,
        quality: 70,
        width: 412,
        height: 494,
        gravity: [0, 0.5],
        dpr: [1, 1.8],
        variant: [
            { breakpoint: 'default', trim: '1200;0;0;0' },
            { breakpoint: 'sm', width: 768, height: 720, gravity: [0, 0.5] },
            { breakpoint: 'md', width: 768, height: 720, gravity: [0.1, 0.5] },
            { breakpoint: 'lg', width: 1264, height: 800, dpr: [1], gravity: [0, 0.6], quality: 80 },
            { breakpoint: 'xl', width: 1520, height: 947, dpr: [1], gravity: [0.5, 0.6], quality: 90 },
            { breakpoint: 'xxl', width: 1920, height: 800, dpr: [1], gravity: [0, 0.5], quality: 90 }
        ]
    },
    {
        debug: false,
        src: 'IMG_20230125_110948.jpg',
        preload: false,
        quality: 70,
        width: 412,
        height: 494,
        gravity: [0, 0.5],
        dpr: [1, 1.8],
        variant: [
            { breakpoint: 'default', trim: '500;300;500;700' },
            { breakpoint: 'sm', width: 768, height: 720, gravity: [0.3, 0.5], trim: '500;300;500;700' },
            { breakpoint: 'md', width: 768, height: 720, gravity: [0.1, 0.5] },
            { breakpoint: 'lg', width: 1264, height: 800, dpr: [1], gravity: [0, 0.4], quality: 80 },
            { breakpoint: 'xl', width: 1520, height: 947, dpr: [1], gravity: [0.5, 0.4], quality: 90 },
            { breakpoint: 'xxl', width: 1920, height: 800, dpr: [1], gravity: [0, 0.4], quality: 90 }
        ]
    }
];

// const images: ImageSlider[] = [
//     { src: 'DSC00696.jpg', preload: true },
//     { src: 'IMG_20250215_210534.jpg', gravity: { xxl: [0.5, 0.7], lg: [0.5, 0.1], md: [0, 0], sm: [0.5, 0.5], default: [0.3, 0.5] } },
//     { src: 'IMG_20230125_110948.jpg', gravity: { xxl: 'auto' } }
// ];

const slideContent: ContentSlide[] = [
    {
        title: 'Air Et Montagne',
        description: 'Explorez la montagne autrement',
        buttonText: 'Découvrir',
        buttonLink: 'activites-parapente'
    },
    {
        title: 'Ski de randonnée',
        description: 'Liberté, aventure, effort et plaisir de la glisse en montagne',
        buttonText: 'Découvrir',
        buttonLink: 'activites-ski'
    },
    {
        title: 'Cours de ski',
        description: "S'initier, se perfectionner, découvrir la montagne",
        buttonText: 'Découvrir',
        buttonLink: 'activites-ski'
    },
    {
        title: 'Ski Hors-Piste',
        description: 'Explorer, progresser et redécouvrir la montagne',
        buttonText: 'Découvrir',
        buttonLink: 'activites-ski-randonnee'
    }
];

function indeChange(index: number) {
    indexslide.value = index;
}
</script>
